
import { Component, Prop } from 'vue-property-decorator'
import { PIB, PIB_BE, PROP_UNIT_ID, PROP_AMOUNT_ID, IS_BE_STORE, CURRENT_STORE } from '../helpers/constants'
import { findPropWithId } from '../helpers/functions'
import Mixin from '../helpers/mixin'
import { Asset } from '../helpers/types'

@Component({})
export default class ProductDetail extends Mixin {
  @Prop() assets!: Asset[]
  @Prop() properties!: any
  @Prop() headerHeight!: number

  isScrolling = false

  anchorChangeTimeout: number | undefined = undefined

  get hasPIB(): boolean {
    if (!this.assets || this.assets.length === 0) return false
    // Code for BE before release with multiproposition, BE showed only PIB_BE
    // const pibAssetName = IS_BE_STORE ? PIB_BE : PIB
    const pibAssetName = PIB
    return !!this.assets.find(asset => asset.group === pibAssetName)
  }

  get hasAssetsWIthoutPIB(): boolean {
    if (!this.assets || this.assets.length === 0) return false
    return !!this.assets.find(asset => asset.group !== PIB && asset.group !== PIB_BE)
  }

  get amount(): string {
    return findPropWithId(this.properties, PROP_AMOUNT_ID, '20')
  }

  get unit(): string {
    return findPropWithId(this.properties, PROP_UNIT_ID, '')
  }

  scrollToElement(id: string, heroHeight: number) {
    if(!this.isTabletP && !this.isPhone && (heroHeight > 120)){

      const element = document.getElementById(id);
      const headerOffset = 170;
      if(element){
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }

  correctScrolling(ev: any, id: string, timeoutTime: number){
    if (this.anchorChangeTimeout) clearTimeout(this.anchorChangeTimeout)
    const hero = document.querySelector('.hero-text-media')
    const heroHeight = hero ? hero.clientHeight : 0
    this.anchorChangeTimeout = window.setTimeout(() => this.scrollToElement(id, heroHeight), timeoutTime)
  }

  getHrefPhoneTablet(href: string){
    return this.isPhone || this.isTabletP ? href : ''
  }
}
